// @flow
import type {
  RequestResetPasswordOperator,
  RequestResetPasswordOperation,
} from '../../types'

// Action Types
import {
  REQUEST_RESET_PASSWORD,
} from 'fc-auth/src/constants'

// Constants
import {
  RESET_PASSWORD_URL,
} from '../constants'

// Effect Managers
import { call, put, select, take } from 'redux-saga/effects'

// Request Reset Operator
import requestResetOperator from '../requestResetPasswordOperator'

// Selectos
import requestResetOperation$ from '../selectors/requestResetPasswordOperation'

// Utils
import { __post } from 'hfty-fetch'
import decodeBadResponse from 'fc-decoders/src/badResponse'

// Exports
export default function *watchResetPasswordRequest (): Generator<*, *, *> {
  const operator: RequestResetPasswordOperator = requestResetOperator()
  const operation = operator.create({
    model: { identifier: '', url: '' },
  })

  yield put(operator.actionCreators.add(operation))

  while (true) {
    yield take(REQUEST_RESET_PASSWORD)

    const requestResetOperation: RequestResetPasswordOperation = yield select(requestResetOperation$)

    yield put(operator.actionCreators.updateOperation({
      ...requestResetOperation,
      errors: [],
      submitting: true,
    }))


    // Obtain url from browser address bar
    let url: string = document.location.href.match(/^(.*)\/[^/]*$/)[1]

    if (url.split('/')[2].split('.')[0] === '10' || url.split('/')[2].split('.')[0] === '192') {
      url = 'https://hefty-qa.granduke.net'
    }

    const model = {
      ...requestResetOperation.model,
      url,
    }

    const newOperation = {
      ...operation,
      model,
    }

    const nextOperation = yield call(handleSubmitOperation, newOperation, operator)

    const action = operator.actionCreators.updateOperation(nextOperation)
    yield put(action)
  }
}

export function *handleSubmitOperation (
  operation: RequestResetPasswordOperation,
  operator: RequestResetPasswordOperator): Generator<*, RequestResetPasswordOperation, *> {
  try {
    const response = yield call(__post, {
      path: RESET_PASSWORD_URL,
      body: operation.model,
      excludeToken: true,
    })

    if (response.status >= 200 && response.status < 300) {
      const nextOperation = {
        ...operation,
        submitting: false,
        success: true,
      }
      const action = operator.actionCreators.updateOperation(nextOperation)
      yield put(action)

      return nextOperation
    } else {
      const json = yield call([response, response.json])
      const nextOperation = {
        ...operation,
        submitting: false,
        success: false,
        errors: decodeBadResponse(json),
      }

      const action = operator.actionCreators.updateOperation(nextOperation)
      yield put(action)

      return nextOperation
    }
  } catch (e) {
    console.warn('There has been an error requesting to reset password.')
  }
}
